export const unique = (a) => {
  const r = [];
  a.forEach((e) => r.indexOf(e) === -1 && r.push(e));
  return r;
}